import { WalletKycStatus } from '../../../types/wallet/Walletkyc';
import { request } from '../../../utils/request';

export default function getWalletKycStatus(props: {
  includeDocuments?: false;
  includeDirectors?: false;
  authToken: string;
}): Promise<WalletKycStatus> {
  return request({
    url: `/sterling/kyc/status`,
    method: 'GET',
    params: {
      include_documents: props.includeDocuments ? 'true' : 'false',
      include_directors: props.includeDirectors ? 'true' : 'false',
    },
    headers: { Authorization: `Bearer ${props.authToken}` },
  });
}
